export function ssnoValidation(value: string, minAge: number = 0): { invalidAge?: boolean, invalidSsno?: boolean } {

    let cleanedValue = value.replace('-', '');

    let date = new Date();

    let year = -1;
    let month = -1;
    let day = -1;

    let ssno10: string;

    if (cleanedValue.length === 10) {
        ssno10 = cleanedValue;

        // Get latest full year
        let yearDec: number = parseInt(ssno10.slice(0, 2));
        year = Math.floor(date.getFullYear() / 100 - (date.getFullYear() % 100 <= yearDec ? 1 : 0)) * 100 + yearDec;
    } else if (cleanedValue.length === 12) {
        ssno10 = cleanedValue.slice(2);
        // Get user entered full year
        year = parseInt(cleanedValue.slice(0, 4));
    } else {
        // Not a valid length
        return { invalidSsno: true };
    }

    month = parseInt(ssno10.slice(2, 4));
    day = parseInt(ssno10.slice(4, 6));

    let ssnoDateMS = Date.parse(`${year}-${month <= 9 ? '0' + month : month}-${day <= 9 ? '0' + day : day}`);

    if (year === -1 || month === -1 || day === -1 ||
        isNaN(ssnoDateMS) ||
        ssnoDateMS > date.getTime()) {
        // Not a valid date
        return { invalidSsno: true };
    }

    let age = new Date(date.getTime() - ssnoDateMS).getFullYear() - 1970;

    if (age < minAge) {
        // Not a valid age
        return { invalidAge: true };
    }

    // Luhn's algorithm
    let sum = ssno10
        .slice(null, 9)
        .split('')
        .map((x) => parseInt(x, 10))
        .reduce((prev, curr, i) => {
            let result = curr * ((i + 1) % 2 + 1);

            let sum2 = result
                .toString()
                .split('')
                .map((x) => parseInt(x, 10))
                .reduce((prev2, curr2) => prev2 + curr2, 0);

            return prev + sum2;
        }, 0);

    if (((10 - (sum % 10)) % 10).toString() !== ssno10[9]) {
        // Not a valid Luhn control digit
        return { invalidSsno: true };
    }

    return {};
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./~/@teamui/validation/validation/ssno.ts
 **/